import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import ExteriorHome from "@/assets/Img/exterior-home.jpg";
import HeadingSavingsEn from "@/assets/Img/heading-savings-en.png";
import HeadingSavingsEs from "@/assets/Img/heading-savings-es.png";
import HeadingSavingsMobileEn from "@/assets/Img/heading-savings-mobile-en.png";
import HeadingSavingsMobileEs from "@/assets/Img/heading-savings-mobile-es.png";
import { Button } from "@/components/Button";
import { SellingCard } from "@/components/SellingCard";
import FxIcon from "@/assets/Icons/fx.svg?react";
import TransactionIcon from "@/assets/Icons/transaction.svg?react";
import ServiceIcon from "@/assets/Icons/service.svg?react";
import MartoriFarms from "@/assets/Img/BusinessPartnersLogos/martori-farms.svg?react";
import CostaFarms from "@/assets/Img/BusinessPartnersLogos/costa-farms.svg?react";
import InAndOut from "@/assets/Img/BusinessPartnersLogos/in-and-out.svg?react";
import ClaroPay from "@/assets/Img/BusinessPartnersLogos/claro-pay.svg?react";
import Associa from "@/assets/Img/BusinessPartnersLogos/associa.svg?react";
import CaboDelSol from "@/assets/Img/BusinessPartnersLogos/cabo-del-sol.svg?react";
import WolfCompany from "@/assets/Img/BusinessPartnersLogos/wolf-company.svg?react";
import RainmakerGroup from "@/assets/Img/BusinessPartnersLogos/rainmaker-group.svg?react";
import GeeAutomotive from "@/assets/Img/BusinessPartnersLogos/gee-automotive.svg?react";
import Anierm from "@/assets/Img/BusinessPartnersLogos/anierm.svg?react";
import ChamberNorthwest from "@/assets/Img/BusinessPartnersLogos/chamber-northwest.svg?react";
import ChamberInter from "@/assets/Img/BusinessPartnersLogos/chamber-inter.svg?react";
import CaboSpot from "@/assets/Img/BusinessPartnersLogos/cabo-spot.svg?react";
import Strike from "@/assets/Img/BusinessPartnersLogos/stryke.svg?react";
import finviarEnLogo from "@/assets/Img/BusinessPartnersLogos/finviar_en.png";
import finviarEsLogo from "@/assets/Img/BusinessPartnersLogos/finviar_es.png";
import CountriesGraphic from "@/assets/Img/countries-graphic.png";
import CountriesGraphicEs from "@/assets/Img/countries-graphic-es.png";
import CountriesGraphic2 from "@/assets/Img/countries-graphic-2.png";
import CountriesGraphic3Es from "@/assets/Img/countries-graphic-3-es.png";
import CountriesGraphic3En from "@/assets/Img/countries-graphic-3-en.png";
import CountriesGraphic4 from "@/assets/Img/countries-graphic-4.png";
import SavingsGraphicEn from "@/assets/Img/savings-graphic-en.png";
import SavingsGraphicEs from "@/assets/Img/savings-graphic-es.png";
import SavingsGraphicMobileEn from "@/assets/Img/savings-graphic-mobile-en.png";
import SavingsGraphicMobileEs from "@/assets/Img/savings-graphic-mobile-es.png";
import SilentSinger from "@/assets/Img/silent-singer.jpg";
import WomanDesk from "@/assets/Img/woman-desk.jpg";
import CameraStudio from "@/assets/Img/camera-studio.jpg";
import BeachAerial from "@/assets/Img/beach-aerial.jpg";
import PeopleSunshine from "@/assets/Img/people-sunshine.jpg";
import sendolaPayBusiness from "@/assets/Img/sendolapay-business-logo.png";
import { NumberedCard } from "@/components/NumberedCard";
import { GradientImageCard } from "@/components/GradientImageCard";
import { PremiumServiceBanner } from "@/components/PremiumServiceBanner";
import { useTranslation } from "react-i18next";
import Marquee from "react-fast-marquee";
import { Modal } from "@/components/Modal";
import HubspotContactForm from "@/components/HubspotContactForm";
import classNames from "classnames";
import { BusinessFaqs } from "@/components/BusinessFaqs";

const titleClassname =
  "text-3xl md:text-4xl font-light text-center inner-span-semibold px-6 lg:px-10";

export default function BusinessPage() {
  const [t] = useTranslation("global");
  const [tBusiness, i18n] = useTranslation("business");
  const lang = i18n.language;
  const [showBanner, setShowBanner] = useState<boolean>(false);
  const [isBannerSticky, setIsBannerSticky] = useState<boolean>(false);
  const [isCreateAccountModalOpen, setIsCreateAccountModalOpen] =
    useState<boolean>(false);
  const [loadingForm, setLoadingForm] = useState<boolean>(true);
  const bannerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!window) return;

    if (window.location?.hash) {
      const id = window.location.hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) element.scrollIntoView();
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      if (scrollY > 600) setShowBanner(true);
      else setShowBanner(false);
    };

    if (bannerRef?.current) {
      const windowHeight = window.innerHeight;
      const banner = bannerRef?.current;
      const elementBottom = banner.getBoundingClientRect().bottom;

      const distanceToBottom = windowHeight - elementBottom;

      if (distanceToBottom > 0) {
        setIsBannerSticky(false);
      } else {
        setIsBannerSticky(true);
      }
    }

    document.addEventListener("scroll", handleScroll);

    return () => document.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>SendolaPay Business | Inicio</title>
      </Helmet>

      <div className="w-full flex flex-col">
        <div id="top" className="relative w-full">
          <img
            src={ExteriorHome}
            className="w-full h-[42rem] sm:max-h-[40rem] object-cover"
          />
          <div className="absolute flex justify-center top-0 left-0 w-full h-full bg-black/30">
            <div className="flex flex-col md:flex-row items-center justify-center xl:justify-evenly gap-8 lg:gap-20 w-full h-full max-w-screen-xl px-6 lg:px-10">
              <div className="flex flex-col gap-2 w-full sm:w-4/5 md:w-1/2 max-w-md">
                <h1
                  className="inner-span-semibold text-white text-2xl md:text-3xl lg:text-4xl font-light"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("Heading.Title"),
                  }}
                />
                <h2
                  className="inner-span-bolden text-white text-lg md:text-xl lg:text-2xl"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("Heading.Subtitle"),
                  }}
                />
                <div className="flex gap-2 mt-8">
                  <Button
                    className="!bg-black !text-business-green !border-[2px] !border-business-green !px-4 hover:!bg-stone-950 hover:!opacity-100"
                    size="sm"
                    text={tBusiness("Buttons.CreateAccount")}
                    onClick={() => setIsCreateAccountModalOpen(true)}
                  />
                  <Button
                    className="bg-white !border-0 !px-4 !text-black hover:bg-gray-200 !font-light"
                    variant="secondary"
                    size="sm"
                    text={tBusiness("Buttons.ContactUs")}
                    link="/business/contact"
                  />
                </div>
              </div>

              <img
                src={lang === "en" ? HeadingSavingsEn : HeadingSavingsEs}
                className="hidden sm:block w-1/2 xl:w-1/2 max-h-[30rem] object-contain"
              />
              <img
                src={
                  lang === "en"
                    ? HeadingSavingsMobileEn
                    : HeadingSavingsMobileEs
                }
                className="sm:hidden w-4/5 max-h-[24rem] object-contain"
              />
            </div>
          </div>
        </div>

        <div className="w-full flex justify-center items-center py-12 bg-sendolab-gray3">
          <div className="w-full flex flex-col gap-6 max-w-screen-xl px-6 lg:px-10">
            <h1
              className={classNames(titleClassname, "!text-white")}
              dangerouslySetInnerHTML={{
                __html: tBusiness("Experience.Title"),
              }}
            />
            <div className="inline-flex justify-center flex-wrap gap-4 mt-4">
              <SellingCard
                className="sm:max-w-[45%] lg:max-w-[32%]"
                element={<FxIcon className="w-10 h-10 text-business-green" />}
                title={tBusiness("Experience.Cards.Card1.Title")}
                paragraph1={tBusiness("Experience.Cards.Card1.Paragraph1")}
                paragraph2={tBusiness("Experience.Cards.Card1.Paragraph2")}
              />
              <SellingCard
                className="sm:max-w-[45%] lg:max-w-[32%]"
                element={
                  <TransactionIcon className="w-10 h-10 text-business-green" />
                }
                title={tBusiness("Experience.Cards.Card2.Title")}
                paragraph1={tBusiness("Experience.Cards.Card2.Paragraph1")}
                paragraph2={tBusiness("Experience.Cards.Card2.Paragraph2")}
              />
              <SellingCard
                className="sm:max-w-[45%] lg:max-w-[32%]"
                element={
                  <ServiceIcon className="w-10 h-10 text-business-green" />
                }
                title={tBusiness("Experience.Cards.Card3.Title")}
                paragraph1={tBusiness("Experience.Cards.Card3.Paragraph1")}
                paragraph2={tBusiness("Experience.Cards.Card3.Paragraph2")}
              />
            </div>
            <p className="w-full text-center text-stone-400 text-xs md:text-sm">
              {tBusiness("Experience.Disclaimer1")}
            </p>
          </div>
        </div>

        <div
          id="global-reach"
          className="w-full flex justify-center py-12 px-6 lg:px-10 bg-sendolab-white2"
        >
          <div className="flex flex-col gap-2 justify-center items-center max-w-screen-xl">
            <h1
              className={titleClassname}
              dangerouslySetInnerHTML={{
                __html: tBusiness("GlobalReach.Title"),
              }}
            />
            <p
              className="text-center inner-span-bolden font-light"
              dangerouslySetInnerHTML={{
                __html: tBusiness("GlobalReach.Subtitle"),
              }}
            />

            <div className="hidden sm:block">
              <img
                className="object-contain w-full mt-10 max-w-screen-lg"
                src={lang === "en" ? CountriesGraphic : CountriesGraphicEs}
              />
              <p className="text-sm text-stone-500 text-center">
                {tBusiness("GlobalReach.Disclaimer1")}
              </p>
            </div>

            <div className="flex flex-col w-full gap-4 sm:hidden mt-8">
              <div className="flex flex-col items-center gap-3 w-full p-6 rounded-3xl bg-sendolab-gray3">
                <p
                  className="text-lg font-semibold text-slate-400 text-center"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("GlobalReach.Cards.Card1.Title"),
                  }}
                />
                <p
                  className="text-sendolab-white2 text-sm inner-span-bolden font-light"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("GlobalReach.Cards.Card1.Paragraph1"),
                  }}
                />
                <img
                  className="h-auto w-full object-contain max-w-72"
                  src={
                    lang === "en" ? CountriesGraphic3Es : CountriesGraphic3En
                  }
                />
                <p
                  className="text-xs font-light text-sendolab-gray5"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("GlobalReach.Cards.Card1.Disclaimer1"),
                  }}
                />
              </div>
              <div className="flex flex-col items-center gap-3 w-full p-6 rounded-3xl bg-sendolab-gray3">
                <p
                  className="text-lg font-semibold text-slate-400 text-center"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("GlobalReach.Cards.Card2.Title"),
                  }}
                />
                <div className="flex max-[350px]:flex-col items-center gap-4">
                  <img
                    className="h-auto w-full object-contain max-w-32"
                    src={CountriesGraphic4}
                  />
                  <p
                    className="text-sendolab-white2 max-[350px]:text-center text-sm inner-span-bolden font-light"
                    dangerouslySetInnerHTML={{
                      __html: tBusiness("GlobalReach.Cards.Card2.Paragraph1"),
                    }}
                  />
                </div>
                <p
                  className="text-xs font-light text-sendolab-gray5"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("GlobalReach.Cards.Card2.Disclaimer1"),
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="hidden sm:flex w-full justify-center py-10 px-6 lg:px-10 bg-sendolab-white2">
          <div className="flex flex-col md:flex-row items-center gap-10 w-full py-6 px-10 rounded-3xl bg-sendolab-gray3 max-w-screen-xl">
            <div className="flex flex-col w-full flex-1 md:w-1/2">
              <img
                className="object-contain h-auto max-h-52 w-full object-center"
                src={CountriesGraphic2}
              />
              <p className="w-full text-left text-xs lg:text-sm font-medium text-sendolab-white2 pl-[16%]">
                {tBusiness("GlobalReach.Origination")}
              </p>
            </div>
            <div className="flex flex-1 flex-col gap-4 text-sendolab-white2 max-md:mt-4">
              <p className="font-optima text-center md:text-left text-xl md:text-2xl">
                {tBusiness("ExpandHorizons.Title")}
              </p>
              <p
                className="text-sm md:text-base font-light text-center md:text-left inner-span-bolden"
                dangerouslySetInnerHTML={{
                  __html: tBusiness("ExpandHorizons.Paragraph1"),
                }}
              />
            </div>
          </div>
        </div>

        <div
          id="savings"
          className="w-full flex flex-col items-center py-10 px-6 lg:px-10 bg-sendolab-white2"
        >
          <div className="flex flex-col w-full gap-8 justify-center items-center max-w-screen-xl">
            <h1
              className={titleClassname}
              dangerouslySetInnerHTML={{
                __html: tBusiness("SmarterPayments.Title"),
              }}
            />
            <img
              className="hidden sm:block object-contain w-full max-w-screen-lg"
              src={lang === "en" ? SavingsGraphicEn : SavingsGraphicEs}
              alt="Saving comparision"
            />
            <img
              className="sm:hidden h-auto w-[110%] max-w-[28rem]"
              src={
                lang === "en" ? SavingsGraphicMobileEn : SavingsGraphicMobileEs
              }
              alt="Saving comparision slim"
            />
          </div>
        </div>

        <div className="flex w-full justify-center pt-10 sm:pb-20 sm:px-6 lg:px-10 bg-sendolab-white2 z-10">
          <div
            id="become-a-member"
            className="w-full rounded-3xl bg-sendolab-gray3 -mb-10 sm:mb-0 py-12 px-8 max-w-screen-xl"
          >
            <h1 className="text-center w-full text-business-green text-2xl md:text-3xl">
              {tBusiness("LevelUp.Title")}
            </h1>
            <p className="text-center w-full text-business-green md:text-xl font-light px-2 max-sm:mt-4">
              {tBusiness("LevelUp.Subtitle")}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-1 md:gap-4 mt-4">
              <NumberedCard
                number={1}
                text={tBusiness("LevelUp.Cards.Card1")}
              />
              <NumberedCard
                number={2}
                text={tBusiness("LevelUp.Cards.Card2")}
              />
              <NumberedCard
                number={3}
                text={tBusiness("LevelUp.Cards.Card3")}
              />
            </div>
          </div>
        </div>

        <div id="premium-service" className="bg-sendolab-white2">
          <div className="w-full flex flex-col items-center py-12 max-sm:pt-20 px-6 lg:px-10 bg-sendolab-gray max-sm:rounded-b-3xl md:bg-sendolab-gray3">
            <PremiumServiceBanner />
          </div>
        </div>

        <div
          id="partners"
          className="flex flex-col items-center py-12 lg:py-14 md:pb-40 bg-sendolab-white2"
        >
          <div className="w-full h-full flex flex-col items-center justify-center gap-6 sm:gap-10">
            <h1
              className={titleClassname}
              dangerouslySetInnerHTML={{ __html: tBusiness("Partners.Title") }}
            />

            <div className="w-full flex flex-col justify-center items-center overflow-hidden py-6">
              <Marquee>
                <MartoriFarms className="text-sendolab-gray5 h-14 w-auto mx-6 md:mx-10" />
                <CostaFarms className="text-sendolab-gray5 h-14 w-auto mx-6 md:mx-10" />
                <InAndOut className="text-sendolab-gray5 h-10 w-auto mx-6 md:mx-10" />
                <ClaroPay className="text-sendolab-gray5 h-14 w-auto mx-6 md:mx-10" />
                <Associa className="text-sendolab-gray5 h-10 w-auto mx-6 md:mx-10" />
                <CaboDelSol className="text-sendolab-gray5 h-10 w-auto mx-6 md:mx-10" />
                <WolfCompany className="text-sendolab-gray5 h-20 w-auto mx-6 md:mx-10" />
                <RainmakerGroup className="text-sendolab-gray5 h-12 w-auto mx-6 md:mx-10" />
                <GeeAutomotive className="text-sendolab-gray5 h-8 w-auto mx-6 md:mx-10" />
                <Anierm className="text-sendolab-gray5 h-14 w-auto mx-6 md:mx-10" />
                <ChamberNorthwest className="text-sendolab-gray5 h-24 w-auto mx-6 md:mx-10" />
                <ChamberInter className="text-sendolab-gray5 h-24 w-min mr-6 md:mr-10" />
                {lang === "en" ? (
                  <img
                    className="h-[86px] 2xl:h-24 w-auto object-contain mx-6 lg:mx-10"
                    src={finviarEnLogo}
                    alt="Claro Pay English Logo"
                  />
                ) : (
                  <img
                    className="h-[86px] 2xl:h-24 w-auto object-contain mx-6 lg:mx-10"
                    src={finviarEsLogo}
                    alt="Claro Pay Spanish Logo"
                  />
                )}
              </Marquee>
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col items-center pt-10 pb-20 px-6 lg:px-10 bg-sendolab-white2">
          <div className="flex flex-col w-full items-center gap-10 max-w-screen-xl">
            <h1
              className={titleClassname}
              dangerouslySetInnerHTML={{
                __html: tBusiness("OtherBusinesses.Title"),
              }}
            />

            <div className="grid grid-cols-1 md:grid-cols-2 md:grid-rows-2 gap-x-5 gap-y-6 md:h-[44rem] w-full">
              <GradientImageCard
                className="max-md:h-[22rem]"
                containerClassname="gap-2"
                imageSrc={SilentSinger}
                moreInfo={
                  <div className="flex flex-col gap-4 px-8 py-4">
                    <p
                      className="text-white text-sm xl:text-base text-center inner-span-bolden font-light"
                      dangerouslySetInnerHTML={{
                        __html: tBusiness(
                          "OtherBusinesses.Cards.Card1.HoverText1"
                        ),
                      }}
                    />
                    <p
                      className="text-white text-sm xl:text-base text-center inner-span-bolden font-light"
                      dangerouslySetInnerHTML={{
                        __html: tBusiness(
                          "OtherBusinesses.Cards.Card1.HoverText2"
                        ),
                      }}
                    />
                  </div>
                }
                moreInfoButton={tBusiness("OtherBusinesses.Cards.Card1.Button")}
                moreInfoButtonClick={() => {
                  if (tBusiness("OtherBusinesses.Cards.Card1.Website")) {
                    window.open(
                      tBusiness("OtherBusinesses.Cards.Card1.Website"),
                      "_blank"
                    );
                  }
                }}
              >
                <div className="flex gap-10">
                  <Strike className="h-6 sm:h-8 lg:h-10 w-auto text-white" />
                  <CaboSpot className="h-6 sm:h-8 lg:h-10 w-auto text-white" />
                </div>

                <p
                  className="text-sendolab-gold3 text-base sm:text-lg text-center font-semibold"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("OtherBusinesses.Cards.Card1.Title"),
                  }}
                />
                <p
                  className="text-sm sm:text-base text-white text-center font-light inner-span-semibold"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("OtherBusinesses.Cards.Card1.Paragraph1"),
                  }}
                />
              </GradientImageCard>
              <GradientImageCard
                className="max-md:h-[22rem]"
                imageSrc={WomanDesk}
                moreInfo={
                  <div className="flex flex-col gap-4 px-8 py-4">
                    <p
                      className="text-white text-sm xl:text-base text-center inner-span-bolden font-light"
                      dangerouslySetInnerHTML={{
                        __html: tBusiness(
                          "OtherBusinesses.Cards.Card2.HoverText1"
                        ),
                      }}
                    />
                    <p
                      className="text-white text-sm xl:text-base text-center inner-span-bolden font-light"
                      dangerouslySetInnerHTML={{
                        __html: tBusiness(
                          "OtherBusinesses.Cards.Card2.HoverText2"
                        ),
                      }}
                    />
                  </div>
                }
              >
                <p
                  className="text-sendolab-gold3 text-base sm:text-xl text-center font-semibold"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("OtherBusinesses.Cards.Card2.Title"),
                  }}
                />
                <p
                  className="text-sm sm:text-base text-white text-center font-light inner-span-semibold"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("OtherBusinesses.Cards.Card2.Paragraph1"),
                  }}
                />
              </GradientImageCard>
              <GradientImageCard
                className="max-md:h-[22rem]"
                imageSrc={BeachAerial}
                moreInfo={
                  <div className="flex flex-col gap-4 px-8 py-4">
                    <p
                      className="text-white text-sm xl:text-base text-center inner-span-bolden font-light"
                      dangerouslySetInnerHTML={{
                        __html: tBusiness(
                          "OtherBusinesses.Cards.Card3.HoverText1"
                        ),
                      }}
                    />
                    <p
                      className="text-white text-sm xl:text-base text-center inner-span-bolden font-light"
                      dangerouslySetInnerHTML={{
                        __html: tBusiness(
                          "OtherBusinesses.Cards.Card3.HoverText2"
                        ),
                      }}
                    />
                  </div>
                }
              >
                <p
                  className="text-sendolab-gold3 text-base sm:text-lg text-center font-semibold"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("OtherBusinesses.Cards.Card3.Title"),
                  }}
                />
                <p
                  className="text-sm sm:text-base text-white text-center font-light inner-span-semibold"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("OtherBusinesses.Cards.Card3.Paragraph1"),
                  }}
                />
              </GradientImageCard>
              <GradientImageCard
                className="max-md:h-[22rem]"
                imageSrc={CameraStudio}
                moreInfo={
                  <div className="flex flex-col gap-4 px-8 py-4">
                    <p
                      className="text-white text-sm xl:text-base text-center inner-span-bolden font-light"
                      dangerouslySetInnerHTML={{
                        __html: tBusiness(
                          "OtherBusinesses.Cards.Card4.HoverText1"
                        ),
                      }}
                    />
                    <p
                      className="text-white text-sm xl:text-base text-center inner-span-bolden font-light"
                      dangerouslySetInnerHTML={{
                        __html: tBusiness(
                          "OtherBusinesses.Cards.Card4.HoverText2"
                        ),
                      }}
                    />
                  </div>
                }
              >
                <InAndOut className="h-9 w-auto text-white flex-shrink-0" />
                <p
                  className="text-sendolab-gold3 text-base sm:text-lg text-center font-semibold"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("OtherBusinesses.Cards.Card4.Title"),
                  }}
                />
                <p
                  className="text-sm sm:text-base text-white text-center font-light inner-span-semibold"
                  dangerouslySetInnerHTML={{
                    __html: tBusiness("OtherBusinesses.Cards.Card4.Paragraph1"),
                  }}
                />
              </GradientImageCard>
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col items-center pt-10 pb-20 px-6 lg:px-10 bg-gradient-to-r from-black via-sendolab-gray2 to-black">
          <div className="flex flex-col w-full items-center gap-8 sm:gap-10 max-w-screen-xl sm:px-10 pt-10 sm:py-20">
            <h1
              className={classNames(titleClassname, "!text-white")}
              dangerouslySetInnerHTML={{
                __html: tBusiness("TrustAndTransparency.Title"),
              }}
            />
            <p
              className="md:max-w-[80%] bg-gradient-to-r from-black via-sendolab-gold4/80 to-black rounded-3xl px-8 py-4 text-center text-white md:text-lg lg:text-xl border-[1px] border-sendolab-gray4"
              dangerouslySetInnerHTML={{
                __html: tBusiness("TrustAndTransparency.Paragraph1"),
              }}
            />
            <div className="relative flex items-center justify-center w-full h-52 sm:h-96 rounded-3xl overflow-hidden sm:mt-10">
              <img
                className="absolute w-full h-full top-0 left-0 object-cover object-top"
                src={PeopleSunshine}
              />
              <div className="absolute top-0 left-0 py-8 px-8 sm:px-14 w-full h-full bg-black/50 flex items-center justify-center">
                <p className="text-white text-lg md:text-2xl lg:text-3xl text-center">
                  {tBusiness("TrustAndTransparency.Paragraph2")}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={bannerRef}
          className={classNames(
            "w-full flex items-center gap-4 shadow-t-lg bg-black border-y-2 border-y-sendolab-gray2 bottom-0 z-20 transition-all delay-100 duration-200 ease-linear py-4 px-6 lg:px-10 min-h-fit",
            {
              sticky: showBanner,
              "h-32 sm:h-24 lg:h-20": showBanner || isBannerSticky,
              "block h-0 overflow-hidden": !showBanner,
            }
          )}
        >
          <div
            className={classNames(
              "w-1/2 md:w-7/12 h-full flex items-center transition-all duration-400 pt-1",
              {
                "max-h-0": !showBanner,
                "max-h-24": showBanner,
              }
            )}
          >
            <p className="w-full text-sm md:text-xl lg:text-2xl text-left text-sendolab-white font-extralight">
              {tBusiness("BeginTheExperience.Title")}
            </p>
          </div>

          <div className="w-1/2 md:w-5/12 flex max-sm:flex-col gap-x-4 gap-y-2 items-center justify-end">
            <Button
              className="!bg-black w-full max-w-60 !text-business-green !border-[2px] !border-business-green !px-2 hover:!bg-stone-950 hover:!opacity-100"
              size="sm"
              text={tBusiness("Buttons.CreateAccount")}
              onClick={() => setIsCreateAccountModalOpen(true)}
            />
            <Button
              className="bg-white w-full max-w-60 !border-0 !px-2 !text-black hover:bg-gray-200 !font-light"
              variant="secondary"
              size="sm"
              text={tBusiness("Buttons.ContactUs")}
              link="/business/contact"
            />
          </div>
        </div>

        <div
          id="faqs"
          className="w-full sm:bg-black bg-gradient-to-r from-black via-sendolab-gray4 to-black py-20 px-10 md:px-20 flex justify-center"
        >
          <BusinessFaqs />
        </div>
      </div>

      <Modal
        withClose
        open={isCreateAccountModalOpen}
        onClose={() => {
          setIsCreateAccountModalOpen(false);
          setLoadingForm(true);
        }}
      >
        <div className="w-full flex flex-col items-center">
          <div className="w-full pb-8 flex justify-between items-center">
            <img
              className="h-9 sm:h-10 md:h-12 xl:h-14 w-auto object-contain select-none"
              src={sendolaPayBusiness}
              alt="SendolaPay Business Logo"
            />
          </div>
          {loadingForm && (
            <p className="w-full text-center text-black font-semibold">
              {t("Loading")}...
            </p>
          )}
          <HubspotContactForm
            region="na1"
            portalId="44207752"
            formId="db94a133-c8f4-47bd-9c41-fdefdc87209a"
            onReady={() => {
              setLoadingForm(false);
            }}
          />
        </div>
      </Modal>
    </>
  );
}
